// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import { slideshowStyles } from "@synd/Overrides/Widgets/Basic/Slideshow";
import { color, mergeWithCss, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

const arrowButtonStyles = {
    mergeCss: true,
    variant: "link" as any,
    css: css`
        &&&:not(:disabled) {
            ${IconWrapper} {
                color: ${color("common.ui7")};
            }
            &:hover {
                ${IconWrapper} {
                    color: ${color("common.ui10")};
                }
            }
            &:focus {
                ${IconWrapper} {
                    color: ${color("common.ui11")};
                }
            }
        }
    `,
};
const arrowWrapperStyles = {
    css: css`
        display: flex;
        ${xScreen("lt", "sm")} {
            flex: 1;
            margin-left: 16px;
        }
    `,
};

slideshowStyles.iconProps = {
    size: 18,
    css: css`
        &,
        svg {
            width: 10px;
        }
    `,
};
slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin-top: 16px;
    `,
};

slideshowStyles.dotButton = {
    css: css`
        border: 1px solid ${color("common.ui9")};
        background: ${color("common.white")};
        width: 10px;
        height: 10px;
        padding: 0;
        min-height: unset;
        &:hover,
        &:active {
            border: 1px solid ${color("common.ui10")};
            background: ${color("common.ui10")};
        }
        &:focus {
            border: 1px solid ${color("common.ui11")};
            background: ${color("common.ui11")};
        }
    `,
};

slideshowStyles.pauseButton = {
    ...arrowButtonStyles,
    ...mergeWithCss(arrowButtonStyles.css, {
        css: css`
            &&&:not(:disabled) {
                ${IconWrapper} {
                    color: ${color("common.ui9")};
                }
                &:hover {
                    ${IconWrapper} {
                        color: ${color("common.ui10")};
                    }
                }
                &:focus {
                    ${IconWrapper} {
                        color: ${color("common.ui11")};
                    }
                }
            }
        `,
    }),
};
slideshowStyles.prevArrowButton = arrowButtonStyles;
slideshowStyles.nextArrowButton = arrowButtonStyles;

slideshowStyles.prevArrowWrapper = {
    ...mergeWithCss(arrowWrapperStyles, {
        css: css`
            margin-right: 8px;
        `,
    }),
};
slideshowStyles.nextArrowWrapper = {
    ...mergeWithCss(arrowWrapperStyles, {
        css: css`
            margin-left: 8px;
            ${xScreen("lt", "sm")} {
                justify-content: flex-end;
                margin-right: 16px;
            }
        `,
    }),
};
